if (!customElements.get('seolab-robots-preview')) {
  customElements.define('seolab-robots-preview', class extends HTMLElement {
    connectedCallback() {
      this.lines = this.querySelector('[data-robots-lines]');
      this.status = this.querySelector('[data-robots-status]');
      this.button = this.querySelector('[data-robots-refresh]');
      if (!this.lines || !this.status) return;

      this.onRefresh = () => this.refresh();
      if (this.button) {
        this.button.hidden = false;
        this.button.addEventListener('click', this.onRefresh);
      }
      if (this.dataset.autoLoad === 'true') this.refresh();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onRefresh);
      this.controller?.abort();
    }

    async refresh() {
      if (this.loading) return;
      this.loading = true;
      const controller = new AbortController();
      this.controller = controller;
      const timeout = setTimeout(() => controller.abort(), 10000);
      this.lines.setAttribute('aria-busy', 'true');
      if (this.button) this.button.disabled = true;
      this.status.textContent = this.dataset.loadingLabel;

      try {
        const response = await fetch('/robots.txt', {
          cache: 'no-store',
          credentials: 'same-origin',
          signal: controller.signal,
          headers: { Accept: 'text/plain' },
        });
        if (!response.ok) throw new Error('Unable to load robots.txt');
        const text = await response.text();
        // Password pages and other HTML responses are not a robots.txt file.
        if (/text\/html/i.test(response.headers.get('content-type') || '') || /^\s*</.test(text)) {
          throw new Error('Expected a plain text robots.txt file');
        }
        if (!this.isConnected) return;

        const fragment = document.createDocumentFragment();
        for (const line of text.replace(/\r\n?/g, '\n').split('\n')) {
          const item = document.createElement('li');
          const code = document.createElement('code');
          code.textContent = line;
          item.append(code);
          fragment.append(item);
        }
        this.lines.replaceChildren(fragment);
        this.status.textContent = this.dataset.liveLabel;
      } catch {
        if (this.isConnected) this.status.textContent = this.dataset.errorLabel;
      } finally {
        clearTimeout(timeout);
        this.lines.removeAttribute('aria-busy');
        if (this.button) this.button.disabled = false;
        this.loading = false;
      }
    }
  });
}
